<template>
    <div class="join-us">
        <!--line1-->
        <ul class="join-con">
            <li>
                <div class="title">
                    <i class="x-icon-why"></i><span class="x-tit-con">Why Choose Xhorse?</span>
                </div>
                <div class="content">
                    <ul class="item block-1">
                        <li class="x-flow"><i class="x-icon-camp-1"></i>
                            <span class="x-inline line-above">To become a member of the national level high-tech
								enterprise</span>
                        </li>
                        <li class="x-flow"><i class="x-icon-camp-2"></i>
                            <span class="x-inline line-above">Enjoy the open laboratory research and development atmosphere</span>
                        </li>
                        <li class="x-flow"><i class="x-icon-camp-3"></i>
                            <span class="x-inline line-above">Work with outstanding peers from top universities at home and
								abroad</span>
                        </li>
                        <li class="x-flow"><i class="x-icon-camp-4"></i>
                            <span class="x-inline line-above">Professional talent training mode to start your excellent working
								life</span>
                        </li>
                    </ul>
                    <div class="x-sep x-clear"></div>
                    <ul class="item block-2">
                        <li class="x-flow"><i class="x-icon-camp-5"></i>
                            <span class="x-inline line-under">Comfortable Staff Apartments</span>
                            <p class="txt">Provide a one-year free staff apartment for graduates.</p>
                        </li>
                        <li class="x-flow"><i class="x-icon-camp-6"></i>
                            <span class="x-inline line-under">Various Types of Allowances</span>
                            <p class="txt">Allowance for meals, transportation, and rent.</p>
                        </li>
                        <li class="x-flow"><i class="x-icon-camp-7"></i>
                            <span class="x-inline line-under">Dinner Parties</span>
                            <p class="txt">Thoughtful afternoon tea, holiday dinners, etc.</p>
                        </li>
                        <li class="x-flow"><i class="x-icon-camp-8"></i>
                            <span class="x-inline line-under">Colorful Tourism</span>
                            <p class="txt">You'll have several chances of tourism at home and abroad each year.</p>
                        </li>
                        <li class="x-flow"><i class="x-icon-camp-9"></i>
                            <span class="x-inline line-under">Holiday Gifts</span>
                            <p class="txt">
                                Lots of holiday gifts for employees on Birthday, Children's Day, Dragon Boat Festival, etc. </p>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
        <div class="x-line x-clear"></div>

        <!--line2-->
        <ul class="join-con" style="margin-bottom: 64px !important;">
            <li>
                <div class="title">
                    <i class="x-icon-person"></i><span class="x-tit-con">What kind of talents are we looking for?</span>
                </div>
                <div class="content">
                    <div class="">
                        <img :src="image_10" alt="Xhorse" style="width: 100%;"/>
                    </div>
                    <div class="key-f">
                        <ul>
                            <li>Excellent academic background.</li>

                            <li>The ability and potential to solve problems - We will lead you to a bigger world.</li>

                            <li>The outstanding ability of R&D or leadership.</li>

                            <li>Great passion and enthusiasm for the high-tech industry.</li>

                            <li>
                                Look up at the starry sky, stand on solid ground. Not only have a dream, but also try to achieve it by working hard.
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
        </ul>
        <div class="x-line x-clear"></div>

        <!--line3-->
        <ul class="join-con">
            <li>
                <div class="title">
                    <i class="x-icon-offer"></i><span class="x-tit-con">What kind of positions do we offer?</span>
                </div>
                <div class="content">
                    <ul>

                        <li class="lx x-flow">
                            <router-link :to="{name: 'apply', params:{ activeName: 1, ActiveScope: 2 }}">
                                <i class="x-icon-pos-1 x-inline"></i>
                                <span
                                        class="x-inline pos-list-con">Mechanical motion control algorithm	engineer</span>
                            </router-link>
                        </li>


                        <li class="lx x-flow">
                            <router-link :to="{name: 'apply', params:{ activeName: 1, ActiveScope: 2 }}">
                                <i class="x-icon-pos-2 x-inline"></i>
                                <span class="x-inline pos-list-con">QT engineer</span>
                            </router-link>
                        </li>


                        <li class="lx x-flow">
                            <router-link :to="{name: 'apply', params:{ activeName: 1, ActiveScope: 2 }}">
                                <i class="x-inline"></i>
                                <span class="x-inline pos-list-con x-more">+ Find more positions</span>
                            </router-link>
                        </li>


                    </ul>
                </div>
            </li>
        </ul>
        <div class="x-line x-clear"></div>

        <!--line4-->
        <ul class="join-con">
            <li>
                <div class="title">
                    <i class="x-icon-plan"></i><span class="x-tit-con">Training Plan</span>
                </div>
                <div class="content">
                    <div class="plan-con">
                        <img :src="image_11" alt="Xhorse"/>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
	import image_10 from '@/assets/resource/images/join/image_recruit_10.png'
	import image_11 from '@/assets/resource/images/join/image_recruit_11.png'
	export default {
		data(){
			return {
				image_10: image_10,
				image_11: image_11
			};
		}
	}

</script>

<style scoped>
    .x-tit-con {
        display: inline-block;
        width: calc(100% - 3.75rem);
        height: 2.75rem;
        font-family: Open Sans;
        font-size: 1.5rem;
        color: #3B3A38;
    }

    .lx a {
        display: block;
        width: 100%;
        height: 100%;
    }

    .content .lx:hover {
        transform: scale(1.024);
    }

    .content .lx {
        width: calc((100% - 2.25rem) / 2);
        height: 7.125rem;
        background: #FBFBFB;
        border-radius: .25rem;
        margin-bottom: 2rem;
        position: relative;
    }

    .content .lx:nth-child(odd) {
        /*margin-left: 44px;*/
    }

    .content .lx:nth-child(even) {
        margin-left: 2.25rem;
    }

    .key-f > ul > li {
        list-style-image: url("../../../assets/resource/icons/ico_sociology_square.png");
        font-family: Open Sans;
        font-size: 1rem !important;
        color: #515555;
        letter-spacing: 0;
        text-align: justify;
        line-height: 1.5rem;

    }

    .key-f > ul > li:not(:last-child) {
        margin-bottom: .625rem;
    }

    .key-f > ul {
        margin-left: .875rem;
    }

    .block-2 > li:not(:last-child) {
        margin-bottom: 1.375rem;
    }

    .item p.txt {
        width: calc(100% - 3.75rem);
        font-size: 1rem;
        color: #515555;
        letter-spacing: 0;
        text-align: left;
        line-height: 1.5rem;
        margin-left: 3.75rem;
    }

    .line-under {
        width: calc((100% - 3.75rem));
        line-height: 2.75rem;
        font-size: 1rem;
        color: #3B3A38;
        letter-spacing: 0;
        text-align: justify;
        font-family: "Open SB";
    }

    .line-above {
        width: calc((100% - 3.75rem));
        line-height: 1.5rem;
        font-size: 1rem;
        color: #3B3A38;
        letter-spacing: 0;
        text-align: left;
    }

    .item > li {
        width: 25.75rem;
        border: none;
        height: 5.625rem;
    }

    .item > li:nth-child(even) {
        margin-left: 3rem;
    }

    .join-con {
        width: 61.5rem;
        margin-left: 0;
        margin-top: 2.75rem;
        margin-bottom: 2.75rem;
        line-height: 2.75rem;
    }

    .join-us {
        width: 100%;
        height: 100%;
    }

    .join-us > .join-con:nth-child(1) {
        height: 40.625rem;
    }

    .x-line {
        width: 100%;
        height: .75rem;
        border: none;
        background-color: #F7F8F8;
    }

    .title {
        width: 58.25rem;
        text-align: left;
        margin-left: 3.25rem;
        margin-bottom: 2.75rem;
    }

    .title > .x-icon-why {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_recruit_xhorse.png");
        width: 44px;
        height: 44px;
        position: relative;
        top: .625rem;
        margin-right: .625rem;
    }

    .x-icon-camp-1 {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_school_reason_01.png");
        width: 2.75rem;
        height: 2.75rem;
        position: relative;
        top: .3125rem;
        margin-right: .625rem;
    }

    .x-icon-camp-2 {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_sociology_reason_team.png");
        width: 2.75rem;
        height: 2.75rem;
        position: relative;
        top: .3125rem;
        margin-right: .625rem;
    }

    .x-icon-camp-3 {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_school_reason_02.png");
        width: 2.75rem;
        height: 2.75rem;
        position: relative;
        top: .3125rem;
        margin-right: .625rem;
    }

    .x-icon-camp-4 {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_school_reason_03.png");
        width: 2.75rem;
        height: 2.75rem;
        position: relative;
        top: .3125rem;
        margin-right: .625rem;
    }

    .x-icon-camp-5 {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_school_reason_04.png");
        width: 2.75rem;
        height: 2.75rem;
        position: relative;
        top: 2.1875rem;
        margin-right: .625rem;
    }

    .x-icon-camp-6 {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_school_reason_05.png");
        width: 2.75rem;
        height: 2.75rem;
        position: relative;
        top: 2.1875rem;
        margin-right: .625rem;
    }

    .x-icon-camp-7 {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_school_reason_06.png");
        width: 2.75rem;
        height: 2.75rem;
        position: relative;
        top: 2.1875rem;
        margin-right: .625rem;
    }

    .x-icon-camp-8 {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_school_reason_07.png");
        width: 2.75rem;
        height: 2.75rem;
        position: relative;
        top: 2.1875rem;
        margin-right: .625rem;
    }

    .x-icon-camp-9 {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_sociology_reason_welfare.png");
        width: 2.75rem;
        height: 2.75rem;
        position: relative;
        top: 2.1875rem;
        margin-right: .625rem;
    }

    .join-us .x-sep {
        width: 100%;
        border: none;
        height: .5px;
        background-color: #D7D7D7;
    }

    .join-con .content {
        height: 100%;
        margin-left: 7rem;
        width: 54.5rem;
        border: none;
    }

    .title > .x-icon-why {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_recruit_xhorse.png");
        width: 2.75rem;
        height: 2.75rem;
        position: relative;
        top: .625rem;
        margin-right: .625rem;
    }

    .x-icon-lock {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_sociology_reason_post.png");
        width: 2.75rem;
        height: 2.75rem;
        position: relative;
        top: .625rem;
        margin-right: .625rem;
    }

    .x-icon-team {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_sociology_reason_team.png");
        width: 2.75rem;
        height: 2.75rem;
        position: relative;
        top: .625rem;
        margin-right: .625rem;
    }

    .x-icon-plan {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_recruit_develop.png");
        width: 2.75rem;
        height: 2.75rem;
        position: relative;
        top: .625rem;
        margin-right: .625rem;
    }

    .x-icon-person {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_recruit_personnel.png");
        width: 2.75rem;
        height: 2.75rem;
        position: relative;
        top: .625rem;
        margin-right: .625rem;
    }

    .x-icon-offer {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_recruit_position.png");
        width: 2.75rem;
        height: 2.75rem;
        position: relative;
        top: .625rem;
        margin-right: .625rem;
    }

    .x-icon-pos-1 {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_sociology_position_01.png");
        width: 2.75rem;
        height: 2.75rem;
        position: absolute;
        margin-right: .625rem;
        top: 2.3125rem;
        left: 1.875rem;
    }

    .x-icon-pos-2 {
        display: inline-block;
        content: url("../../../assets/resource/icons/ico_sociology_position_02.png");
        width: 2.75rem;
        height: 2.75rem;
        position: absolute;
        margin-right: .625rem;
        top: 2.3125rem;
        left: 1.875rem;
    }

    .pos-list-con {
        /*text-align: left;
        width: 80%;
        height: 114px;
        line-height: 114px;*/
        display: inline-block;
        text-align: left;
        width: calc(100% - 6.25rem);
        height: 7.125rem;
        line-height: 7.125rem;
        font-size: 1.25rem;
        margin-left: 3.75rem;
        padding-left: 1.25rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .x-more {
        font-family: Open Sans;
        font-size: 1.25rem;
        color: #1567E4;
        width: 80%;
        margin: 0 auto;
        text-align: center;
        padding: 0 !important;
    }

    .content > ul > li.lx:nth-last-child(1) {
        margin-bottom: 4rem !important;
    }

    .plan-con img {
        width: 80%;
        margin: 0 auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/zh-cn/join/join-campus.vue